enum AddPeopleToContentTypes {
  Flows = "Flows",
  Events = "Events",
  Surveys = "Surveys",
  Assessments = "Assessments",
  PDFs = "PDFs",
  Uploaded = "Uploaded",
  Embedded = "Embedded",
  Links = "Links",
}
export default AddPeopleToContentTypes;
